import { deserialize } from 'cerialize'

export class ClientLimitSupportInfoModel {
	@deserialize public permitted: boolean
	@deserialize public last_deal_date: string | null
	@deserialize public available_untill_date: string | null
}
